import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// قم بإنشاء عنصر script جديد
const tailwindScript = document.createElement("script");
tailwindScript.src = "https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4";
tailwindScript.defer = true; // تأكد من تحميله بعد تحميل DOM

// أضفه إلى الـ head
document.head.appendChild(tailwindScript);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
